import { IDENTIFIER_TYPE } from 'src/features/membership/types';
import { membershipMessages } from 'src/features/membership/utils/messages';
import { BadgeOption } from 'src/registry/types/badges';
import { ICON_MAP } from 'src/utils/constants';

export const allowListIdentifierTypeBadgeOptions: Record<
    Exclude<IDENTIFIER_TYPE, IDENTIFIER_TYPE.TICKET>,
    BadgeOption
> = {
    [IDENTIFIER_TYPE.ACCESS_KEY]: {
        label: membershipMessages.accessKey,
        icon: ICON_MAP.KEY,
        theme: 'blue',
    },
    [IDENTIFIER_TYPE.LICENSE_PLATE]: {
        label: membershipMessages.licensePlate,
        icon: ICON_MAP.CLIENT,
        theme: 'green',
    },
};
